import { defineStore } from "pinia";
import { useAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationPromotional = defineStore("curation-setting-promotional-field", () => {
  const field = useAdditionalServiceField({
    id: "promotional_options",
    functionalGroupCode: "PROMOTIONAL_OPTIONS",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("promotional_option");

  return { ...field, hasUnpublishedChange };
});
